import React from "react";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-trend-rail.css";

interface Item {
    title: string;
    image_url: string;
    url: string;
    image_alt: string;
}

interface HomepageTrendItemProps {
    item: Item;
}

function HomepageTrendItem({ item }: HomepageTrendItemProps): JSX.Element {
    return (
        <div className={styles.homepageTrendItem}>
            <LazyLoadImage
                className={styles.homepageTrendImg}
                src={item.image_url}
                alt={item.image_alt}
            />
            <a className={styles.homepageTrendLink} href={item.url}>
                {item.title}
            </a>
        </div>
    );
}

interface HomepageTrendRailProps {
    items: Item[];
}

export function HomepageTrendRail({ items }: HomepageTrendRailProps): JSX.Element {
    return (
        <Rail
            className={styles.homepageTrendRail}
            analyticsLabel={"homepage_trend_rail"}
            title={""}
            railClassName={styles.railClass}
            smallRail={true}
        >
            {items.map((item) => {
                return <HomepageTrendItem key={item.url} item={item} />;
            })}
        </Rail>
    );
}

interface HomepageTrendsRailsProps {
    sectionTitle: string;
    womensLinks: Item[];
    mensLinks: Item[];
}

function HomepageTrendRails({
    sectionTitle,
    mensLinks,
    womensLinks,
}: HomepageTrendsRailsProps): JSX.Element {
    return (
        <div className={styles.homepageTrendRails}>
            <h3 className={styles.homepageTrendTitle}>{sectionTitle}</h3>
            <HomepageTrendRail items={womensLinks} />
            <HomepageTrendRail items={mensLinks} />
        </div>
    );
}

export default HomepageTrendRails;
